import { r as registerInstance, c as createEvent, h } from './core-6f498fd9.js';
var CsmPagination = /** @class */ (function () {
    function CsmPagination(hostRef) {
        var _this = this;
        registerInstance(this, hostRef);
        /**
         * Option to display or result per page choice
         */
        this.displayResultPerPage = false;
        /**
         * Option to hide pagination numbers
         */
        this.hidePaginationNumbers = false;
        /**
         *
         */
        this.resultPerPage = 10;
        /**
         * Text label for "results per page"
         */
        this.resultPerPageLabel = 'results per page';
        this.resultPerPageValues = [10, 50, 100];
        this.generatePagination = function () {
            var radius = (_this.pageDisplayed - 1) / 2;
            var values = [];
            var buttonValues = [];
            for (var idx = 1; idx <= _this.pageCount; idx++) {
                if (idx === 1 || idx === _this.pageCount) {
                    values.push(idx);
                }
                else if (idx <= _this.pageDisplayed && _this.page <= _this.pageDisplayed - 1) {
                    values.push(idx);
                }
                else if (idx > _this.pageCount - _this.pageDisplayed && _this.page > _this.pageCount - (_this.pageDisplayed - 1)) {
                    values.push(idx);
                }
                else if (_this.page > _this.pageDisplayed - 1 &&
                    _this.page <= _this.pageCount - (_this.pageDisplayed - 1) &&
                    idx < _this.page + radius + 1 &&
                    idx >= _this.page - radius) {
                    values.push(idx);
                }
            }
            var lastValue;
            for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                var value = values_1[_i];
                if (lastValue && value - lastValue !== 1) {
                    buttonValues.push(null);
                }
                buttonValues.push(value);
                lastValue = value;
            }
            return buttonValues;
        };
        this.onPageSelectHandler = function (page) {
            _this.csmPageSelect.emit({ page: page });
        };
        this.onResultPerPageSelectHandler = function (resultPerPage) {
            _this.csmResultPerPageSelect.emit({ resultPerPage: resultPerPage });
        };
        this.csmPageSelect = createEvent(this, "csmPageSelect", 7);
        this.csmResultPerPageSelect = createEvent(this, "csmResultPerPageSelect", 7);
    }
    CsmPagination.prototype.render = function () {
        var _this = this;
        // Results per page
        var resultPerPageLinks = [].concat.apply([], this.resultPerPageValues.map(function (value, index) {
            var elements = [];
            if (value === _this.resultPerPage) {
                elements.push(h("span", { class: "result-per-page__value --selected" }, value));
            }
            else {
                elements.push(h("span", { class: "result-per-page__value", onClick: function () { return _this.onResultPerPageSelectHandler(value); } }, value));
            }
            if (index != _this.resultPerPageValues.length - 1) {
                elements.push(h("span", null, ", "));
            }
            return elements;
        }));
        // Pagination
        var values = this.generatePagination();
        var paginationButtons = !this.hidePaginationNumbers
            ? values.map(function (value) {
                if (value === _this.page) {
                    //@ts-ignore
                    return h("csm-button", { secondary: true }, value);
                }
                else if (value === null) {
                    return (
                    //@ts-ignore
                    h("csm-button", { tertiary: true, disabled: true }, "..."));
                }
                else {
                    return (
                    //@ts-ignore
                    h("csm-button", { onCsmClick: function () { return _this.onPageSelectHandler(value); }, tertiary: true }, value));
                }
            })
            : [];
        return (h("div", null, this.displayResultPerPage && (h("span", { class: "result-per-page" }, resultPerPageLinks, h("span", null, " ", this.resultPerPageLabel))), this.page <= 1 ? (
        //@ts-ignore
        h("csm-button", { tertiary: true, disabled: true, icon: "arrow-left" })) : (
        //@ts-ignore
        h("csm-button", {
            //@ts-ignore
            tertiary: true, onCsmClick: function () { return _this.onPageSelectHandler(_this.page - 1); }, icon: "arrow-left"
        })), paginationButtons, this.page >= this.pageCount ? (
        //@ts-ignore
        h("csm-button", { tertiary: true, disabled: true, icon: "arrow-right" })) : (
        //@ts-ignore
        h("csm-button", {
            //@ts-ignore
            tertiary: true, onCsmClick: function () { return _this.onPageSelectHandler(_this.page + 1); }, icon: "arrow-right"
        }))));
    };
    Object.defineProperty(CsmPagination, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}csm-button:not(:first-child){margin-left:16px}.result-per-page{padding-right:16px}.result-per-page__value{font-weight:600;cursor:pointer;color:#4b8ae7}.result-per-page__value.--selected{color:#000;cursor:default}"; },
        enumerable: true,
        configurable: true
    });
    return CsmPagination;
}());
export { CsmPagination as csm_pagination };
